import CampaignList from '@/src/components/campaigns/CampaignList';
import React from 'react';

export const CampaignsPage: React.FC = () => {
  return <CampaignList />;
};
